import { NgModule } from '@angular/core';
import { MsHtmlcommandbuttonComponent } from './ms-htmlcommandbutton.component';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HtmlCommandButtonComponent } from './html-command-button/html-command-button.component';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  declarations: [MsHtmlcommandbuttonComponent, HtmlCommandButtonComponent],
  imports: [
    BrowserModule,
    FormsModule,
    CommonModule,
    HttpClientModule
  ],
  exports: [MsHtmlcommandbuttonComponent, HtmlCommandButtonComponent]
})
export class MsHtmlcommandbuttonModule { }
